import React from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'

export default function DeleteFastNoteModal({ isOpen, setIsOpen, id, name, DeleteFastNote, loding }) {

    const handleSubmit = (e) => {
        e.preventDefault()
        DeleteFastNote(id)
    }
    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"Delete Fast Note"}>
            <form onSubmit={handleSubmit}>
                <div class="p-6 space-y-6">
                    <div class="grid grid-cols gap-6">
                        <div class="col-span-12">
                            <h1 className="text-4xl">Are you sure to Delete {name}?</h1>
                        </div>
                    </div>
                </div>
                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b ">
                    {!loding ?
                        <>
                            <button type="submit" className="btn-danger">Delete</button>
                            <button onClick={(e) => { e.preventDefault(); setIsOpen(false) }} className="btn-default" >Cancel</button>
                        </>
                        : <LodingButton text="Wait.." css='btn-danger-disabled' />
                    }
                </div>
            </form>
        </Modal>
    )
}
